export default "__VITE_ASSET__BfgE8K8U__"